//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';
import constant from '~/const';

export default {
  data() {
    return {
      model: {
        verificationType: null,
        verificationAutoType: null,
        verificationSdk: null,
      },
      constant,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapState('settingsVerification', ['data']),
  },

  watch: {
    data() {
      const { verificationType, verificationAutoType, verificationSdk } = this.data;
      this.model.verificationType = verificationType;
      this.model.verificationAutoType = verificationAutoType;
      this.model.verificationSdk = verificationSdk;
    },
  },

  methods: {
    ...mapActions('common', ['confirmAction', 'setGeneralProgress', 'setSuccessNotification']),
    ...mapActions('settingsVerification', ['loadData', 'updateVerificationOptions']),

    handleTypeChange() {
      if (this.model.verificationAutoType === 2) {
        this.model.verificationType = this.constant.settings.VERIFICATION_TYPE.AUTO;
        this.model.verificationSdk = true;
      }
    },

    apply() {
      this.confirmAction({
        title: 'Are you sure you want to update verification options?',
        callback: async () => {
          const { model } = this;
          this.setGeneralProgress(true);
          await this.updateVerificationOptions(model);
          await this.loadData();
          this.setGeneralProgress(false);
          this.setSuccessNotification('Verification options updated successfully');
        },
      });
    },
  },
};
